<template>
  <div class="space-y-6">
    <!-- Regular Schedule -->
    <div class="bg-white rounded-xl p-4 border border-gray-200">
      <h4 class="font-semibold text-gray-800 mb-3 flex items-center">
        <font-awesome-icon icon="clock" class="mr-2 text-blue-600" />
        Regular Schedule (Mon–Thu)
      </h4>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium text-gray-600 mb-1">Start</label>
          <input :value="model.regular_start_time" @input="update('regular_start_time', $event.target.value)" type="time"
            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-200" />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-600 mb-1">End</label>
          <input :value="model.regular_end_time" @input="update('regular_end_time', $event.target.value)" type="time"
            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-200" />
        </div>
      </div>
    </div>

    <!-- Friday -->
    <div class="bg-white rounded-xl p-4 border border-gray-200">
      <h4 class="font-semibold text-gray-800 mb-3 flex items-center">
        <font-awesome-icon icon="calendar-day" class="mr-2 text-blue-600" />
        Friday
      </h4>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium text-gray-600 mb-1">Start</label>
          <input :value="model.friday_start_time" @input="update('friday_start_time', $event.target.value)" type="time"
            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-200" />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-600 mb-1">End</label>
          <input :value="model.friday_end_time" @input="update('friday_end_time', $event.target.value)" type="time"
            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-200" />
        </div>
      </div>
    </div>

    <!-- Lunch -->
    <div class="bg-white rounded-xl p-4 border border-gray-200">
      <h4 class="font-semibold text-gray-800 mb-3 flex items-center">
        <font-awesome-icon icon="utensils" class="mr-2 text-blue-600" />
        Lunch Break
      </h4>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium text-gray-600 mb-1">Start</label>
          <input :value="model.lunch_break_start" @input="update('lunch_break_start', $event.target.value)" type="time"
            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-200" />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-600 mb-1">End</label>
          <input :value="model.lunch_break_end" @input="update('lunch_break_end', $event.target.value)" type="time"
            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-200" />
        </div>
      </div>
    </div>

    <!-- Lecture -->
    <div class="bg-white rounded-xl p-4 border border-gray-200">
      <h4 class="font-semibold text-gray-800 mb-3 flex items-center">
        <font-awesome-icon icon="chalkboard-teacher" class="mr-2 text-blue-600" />
        Lecture / Theory
      </h4>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium text-gray-600 mb-1">Min hours</label>
          <input :value="model.lecture_min_hours" @input="update('lecture_min_hours', parseFloat($event.target.value) || 1.5)" type="number" step="0.5" min="0.5"
            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-200" />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-600 mb-1">Max hours</label>
          <input :value="model.lecture_max_hours" @input="update('lecture_max_hours', parseFloat($event.target.value) || 3)" type="number" step="0.5" min="0.5"
            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-200" />
        </div>
      </div>
    </div>

    <!-- Lab -->
    <div class="bg-white rounded-xl p-4 border border-gray-200">
      <h4 class="font-semibold text-gray-800 mb-3 flex items-center">
        <font-awesome-icon icon="flask" class="mr-2 text-blue-600" />
        Lab
      </h4>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium text-gray-600 mb-1">Min hours</label>
          <input :value="model.lab_min_hours" @input="update('lab_min_hours', parseFloat($event.target.value) || 6)" type="number" step="0.5" min="0.5"
            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-200" />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-600 mb-1">Max hours</label>
          <input :value="model.lab_max_hours" @input="update('lab_max_hours', parseFloat($event.target.value) || 6)" type="number" step="0.5" min="0.5"
            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-200" />
        </div>
      </div>
    </div>

    <!-- Clinical -->
    <div class="bg-white rounded-xl p-4 border border-gray-200">
      <h4 class="font-semibold text-gray-800 mb-3 flex items-center">
        <font-awesome-icon icon="user-md" class="mr-2 text-blue-600" />
        Clinical Practicum
      </h4>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <label class="block text-sm font-medium text-gray-600 mb-1">Min hours</label>
          <input :value="model.clinical_min_hours" @input="update('clinical_min_hours', parseFloat($event.target.value) || 9)" type="number" step="0.5" min="0.5"
            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-200" />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-600 mb-1">Max hours</label>
          <input :value="model.clinical_max_hours" @input="update('clinical_max_hours', parseFloat($event.target.value) || 9)" type="number" step="0.5" min="0.5"
            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-200" />
        </div>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium text-gray-600 mb-1">Start</label>
          <input :value="model.clinical_start_time" @input="update('clinical_start_time', $event.target.value)" type="time"
            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-200" />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-600 mb-1">End</label>
          <input :value="model.clinical_end_time" @input="update('clinical_end_time', $event.target.value)" type="time"
            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-200" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const DEFAULT_CONFIG = {
  id: null,
  regular_start_time: '08:00',
  regular_end_time: '16:00',
  friday_start_time: '08:00',
  friday_end_time: '12:00',
  lunch_break_start: '12:00',
  lunch_break_end: '13:00',
  lecture_min_hours: 1.5,
  lecture_max_hours: 3.0,
  lab_min_hours: 6.0,
  lab_max_hours: 6.0,
  clinical_min_hours: 9.0,
  clinical_max_hours: 9.0,
  clinical_start_time: '06:30',
  clinical_end_time: '23:30'
};

export default {
  name: 'ConfigurationForm',
  props: {
    /** Vue 3 v-model */
    modelValue: {
      type: Object,
      default: null
    },
    /** Vue 2 / legacy */
    value: {
      type: Object,
      default: null
    }
  },
  emits: ['update:modelValue', 'input'],
  computed: {
    mergedSource() {
      var mv = this.modelValue;
      if (mv && typeof mv === 'object') {
        return mv;
      }
      var v = this.value;
      if (v && typeof v === 'object') {
        return v;
      }
      return {};
    },
    model() {
      return { ...DEFAULT_CONFIG, ...this.mergedSource };
    }
  },
  methods: {
    update(field, val) {
      const next = { ...this.model, [field]: val };
      this.$emit('update:modelValue', next);
      this.$emit('input', next);
    },
    getValues() {
      return { ...this.model };
    }
  }
};
</script>
